// extracted by mini-css-extract-plugin
var _1 = "l98tn__entry";
var _2 = "l98tn__list";
export { _1 as "entry", _2 as "list" }
